import React, { createContext, useContext, useEffect, useState } from "react";
import { toast } from "sonner";

const CartContext = createContext(null);
const STORAGE_KEY = "ss_cart";

export const CartProvider = ({ children }) => {
  const [items, setItems] = useState(() => {
    try { return JSON.parse(localStorage.getItem(STORAGE_KEY) || "[]"); } catch { return []; }
  });
  const [wholesaleMode, setWholesaleMode] = useState(false);

  useEffect(() => {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(items));
  }, [items]);

  const addItem = (product, quantity = 1, bulk = false) => {
    setItems((prev) => {
      const existing = prev.find((i) => i.product_id === product.product_id && i.bulk === bulk);
      if (existing) {
        return prev.map((i) => i === existing ? { ...i, quantity: i.quantity + quantity } : i);
      }
      return [...prev, {
        product_id: product.product_id, name: product.name, image: product.image,
        price: product.price, wholesale_price: product.wholesale_price,
        bulk_min_qty: product.bulk_min_qty, quantity, bulk,
      }];
    });
    toast.success(`${product.name} added to cart`);
  };

  const updateQty = (product_id, bulk, quantity) => {
    if (quantity <= 0) return removeItem(product_id, bulk);
    setItems((prev) => prev.map((i) => (i.product_id === product_id && i.bulk === bulk) ? { ...i, quantity } : i));
  };

  const removeItem = (product_id, bulk) => {
    setItems((prev) => prev.filter((i) => !(i.product_id === product_id && i.bulk === bulk)));
  };

  const clear = () => setItems([]);

  const unitPriceFor = (item) => {
    const useWholesale = wholesaleMode || (item.bulk && item.quantity >= (item.bulk_min_qty || 12));
    return useWholesale ? item.wholesale_price : item.price;
  };

  const subtotal = items.reduce((s, i) => s + unitPriceFor(i) * i.quantity, 0);
  const count = items.reduce((s, i) => s + i.quantity, 0);

  return (
    <CartContext.Provider value={{
      items, addItem, updateQty, removeItem, clear,
      subtotal, count, unitPriceFor, wholesaleMode, setWholesaleMode,
    }}>
      {children}
    </CartContext.Provider>
  );
};

export const useCart = () => useContext(CartContext);
